import Head from 'next/head';
import Testimonial from '@/components/Testimonial';

const Page = () => {
  return (
    <>
      <Head>
        <title>Testimonial</title>
      </Head>

      <Testimonial />
    </>
  );
};

export default Page;
